module.exports = __webpack_public_path__ + "media/images/front/materials/polimeros-e5ce1c902f793a11bd2ca8013db5460f.jpg";